import JWPlayer from './JWPlayer.vue'

function plugin (Vue, options) {
  // Exit if the plugin has already been installed.
  if (plugin.installed) return

  require('./jwplayer-8.26.5/jwplayer');

  let jwplayer = null
  let jwcomponent = null

  const VueJWPlayer = new Vue({

    data () {
      return {
        options: options,
        jwplayer: null
      }
    },

    methods: {
      init () {
        this.$l.log('VueJWPlayer initialized', buildEnv, window.jwplayer.version)
        this.jwplayer = window.jwplayer
        window.jwplayer.key = options.key
      }
    }

  })

  VueJWPlayer.init()

  // Extend `Vue.prototype` to include our global event bus.
  Object.defineProperty(Vue.prototype, '$vuejw', {
    get () {
      return VueJWPlayer
    }
  })

  Object.defineProperty(Vue.prototype, '$jwplayer', {
    get () {
      return jwplayer
    },
    set (value) {
      jwplayer = value
    }
  })

  Object.defineProperty(Vue.prototype, '$jwcomp', {
    get () {
      return jwcomponent
    },
    set (value) {
      jwcomponent = value
    }
  })

  Vue.component('jwplayer', JWPlayer)
}

// // Check for `window.Vue`
// if (typeof window !== 'undefined' && window.Vue) {
//     // Install plugin automatically.
//     window.Vue.use(plugin)
// }

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/vue-jwplayer/index.js